// web/src/lib/firebase.ts
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "AIzaSy_mock_key_for_build_process_000000",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "mvplayer-473020.firebaseapp.com",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "mvplayer-473020",
  storageBucket: "mvplayer-473020.firebasestorage.app",
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "000000000000",
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:000000000000:web:0000000000000000000000",
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL, 
};

console.log("Firebase Config Storage Bucket:", firebaseConfig.storageBucket);

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);
const functions = getFunctions(app, "europe-west1");
const auth = getAuth(app);
const storage = getStorage(app);
import { getDatabase } from "firebase/database";
const rtdb = getDatabase(app, "https://mvplayer-473020-default-rtdb.europe-west1.firebasedatabase.app/");
const rtdbSecondary = getDatabase(app, "https://mvplayer-473020-secondary-rtdb.europe-west1.firebasedatabase.app/");

// Connect to emulators if in development
if (process.env.NODE_ENV === "development") {
  connectFunctionsEmulator(functions, "localhost", 5001);
  console.log("Connected to Functions Emulator at localhost:5001");
}

export { db, functions, auth, storage, rtdb, rtdbSecondary, app };
